<template>
  <v-chip
    v-if="text"
    v-bind="$attrs"
    :color="colour"
    :text-color="convertHexToHighContrastColour(colour)"
    @click:close="$emit('click:close', $event)"
  >
    <slot v-if="withStatus" name="status-indicator">
      <v-chip
        :color="statusColour ? statusColour : 'successMedium'"
        :text-color="convertHexToHighContrastColour(statusColour)"
        class="status-indicator mr-1 pa-0"
      />
    </slot>
    {{ text }}
  </v-chip>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { convertHexToHighContrastColour } from "@/app/ui/colourUtils";

export default defineComponent({
  name: "BmChip",
  props: {
    text: {
      type: [Number, String],
      default: null,
    },
    colour: {
      type: String as PropType<string | null>,
      required: false,
      default: null,
    },
    // WithStatus adds a small round status identifier to the left of the text and in the chip
    // This is optional and defaults to green.
    withStatus: {
      type: Boolean,
      required: false,
      default: false,
    },
    statusColour: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup() {
    return {
      convertHexToHighContrastColour,
    };
  },
});
</script>

<style lang="sass" scoped>
.status-indicator
  border-radius: 50%
  height: 1em
  width: 1em
</style>
